// test1929
(1929 && 0);
